import { Navigate, useLocation } from "react-router-dom";
 
const ProtectedRoute = ({ children, type = "public" }) => {
  const location = useLocation();
  const adminEmail = localStorage.getItem("admin_email");
  const accessToken = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
 
  const isUserLoggedIn = accessToken && refreshToken && !adminEmail;
  const isAdminLoggedIn = adminEmail && accessToken;
 
  // Admin-only route - check if navigated from within app or already logged in
  if (type === "admin") {
    const hasNavigationState = location.state?.fromApp === true;
    const isAuthorized = isAdminLoggedIn || hasNavigationState;
    return isAuthorized ? children : <Navigate to="/" replace />;
  }

  // Email verification - check for required query parameters
  if (type === "email-verification") {
    const searchParams = new URLSearchParams(location.search);
    const hasToken = searchParams.has("token");
    return hasToken ? children : <Navigate to="/" replace />;
  }
 
  // Password reset - check for required query parameters
  if (type === "password-reset") {
    const searchParams = new URLSearchParams(location.search);
    const hasToken = searchParams.has("mode") || searchParams.has("oobCode");
    return hasToken ? children : <Navigate to="/" replace />;
  }
 
  // User-only route
  if (type === "user") {
    return isUserLoggedIn ? children : <Navigate to="/" replace />;
  }
 
  // Authenticated route (user or admin)
  if (type === "auth") {
    return isUserLoggedIn || isAdminLoggedIn ? children : <Navigate to="/" replace />;
  }
 
  // Public route - accessible to everyone
  return children;
};
 
export default ProtectedRoute;
